import { useCallback, useEffect, useState } from "react";
import { SectionMap } from "./sections/SectionMap";
import { General } from "./main/General";
import { Manzana1Div1 } from "./manzanas/Manzana1Div1";
import { getLotLands } from "../../../../services/LotLandsService";
import { toast } from "react-toastify";
import { Manzana1Div2 } from "./manzanas/Manzana1Div2";
import Loading from "../../../../components/loading/Loading";
import { useForm } from "react-hook-form";
import { ModalDetails } from "../components/modal/ModalDetails";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "../../../../hooks/useAuth";
import {
  assignLand,
  saveProgress,
} from "../../../../features/userSlice/paymentSlice";
import { useNavigate, useParams } from "react-router-dom";
import { selectClient } from "../../../../features/userSlice/userSlice";
import LandDetails from "../components/LandDetails";
import { Manzana10Div1 } from "./manzanas/Manzana10Div1";
import { Manzana2Div1 } from "./manzanas/Manzana2Div1";
import { Manzana9Div1 } from "./manzanas/Manzana9Div1";
import { Manzana5Div1 } from "./manzanas/Manzana5Div1";
import { Manzana6Div1 } from "./manzanas/Manzana6Div1";
import { Manzana7Div1 } from "./manzanas/Manzana7Div1";
import { Manzana8Div1 } from "./manzanas/Manzana8Div1";
import { Manzana11Div1 } from "./manzanas/Manzana11Div1";
import { Manzana12Div1 } from "./manzanas/Manzana12Div1";
import { Manzana15Div1 } from "./manzanas/Manzana15Div1";
import { Manzana14Div1 } from "./manzanas/Manzana14Div1";
import { Manzana13Div1 } from "./manzanas/Manzana13Div1";
import { Manzana20Div1 } from "./manzanas/Manzana20Div1";
import { Manzana3Div1 } from "./manzanas/Manzana3Div1";
import { Manzana16Div1 } from "./manzanas/Manzana16Div1";
import { Manzana17Div1 } from "./manzanas/Manzana17Div1";
import { Manzana18Div1 } from "./manzanas/Manzana18Div1";
import { Manzana23Div1 } from "./manzanas/Manzana23Div1";
import { Manzana24Div1 } from "./manzanas/Manzana24Div1";
import { Manzana25Div1 } from "./manzanas/Manzana25Div1";
import { Manzana26Div1 } from "./manzanas/Manzana26Div1";
import { Manzana22Div1 } from "./manzanas/Manzana22Div1";
import { Manzana21Div1 } from "./manzanas/Manzana21Div1";
import { Manzana19Div1 } from "./manzanas/Manzana19Div1";
import { Manzana31Div1 } from "./manzanas/Manzana31Div1";
import { Manzana33Div1 } from "./manzanas/Manzana33Div1";
import { Manzana34Div1 } from "./manzanas/Manzana34Div1";
import { Manzana27Div1 } from "./manzanas/Manzana27Div1";
import { Manzana28Div1 } from "./manzanas/Manzana28Div1";
import { Manzana38Div1 } from "./manzanas/Manzana38Div1";
import { Manzana37Div1 } from "./manzanas/Manzana37Div1";
import { Manzana36Div1 } from "./manzanas/Manzana36Div1";
import { Manzana29Div1 } from "./manzanas/Manzana29Div1";
import { Manzana32Div1 } from "./manzanas/Manzana32Div1";
import { Manzana35Div1 } from "./manzanas/Manzana35Div1";
import { Manzana30Div1 } from "./manzanas/Manzana30Div1";
import { Manzana4Div1 } from "./manzanas/Manzana4Div1";
import { Manzana35Div3 } from "./manzanas/Manzana35Div3";
import { Manzana35Div2 } from "./manzanas/Manzana35Div2";
import { Manzana15Div2 } from "./manzanas/Manzana15Div2";
import { Manzana15Div3 } from "./manzanas/Manzana15Div3";
import { PrimaryButton } from "../../../../components/primary/PrimaryButton";
import { Modal } from "flowbite-react";
import { IoCloseCircle } from "react-icons/io5";
import DetailsCard from "./component/DetailsCard";
import C1AndC2Map from "./main/C1AndC2Map";
import Cluster2 from "./sections/Cluster2";
import { Manzana1Div1M2 } from "./manzanasCluster2/Manzana1Div1M2";
import { Manzana2Div1M2 } from "./manzanasCluster2/Manzana2Div1M2";
import { Manzana2Div2M2 } from "./manzanasCluster2/Manzana2Div2M2";
import { Manzana2Div3M2 } from "./manzanasCluster2/Manzana2Div3M2";
import { Manzana3Div1M2 } from "./manzanasCluster2/Manzana3Div1M2";
import { Manzana3Div2M2 } from "./manzanasCluster2/Manzana3Div2M2";
import { Manzana4Div1M2 } from "./manzanasCluster2/Manzana4Div1M2";
import { Manzana5Div1M2 } from "./manzanasCluster2/Manzana5Div1M2";
import { Manzana6Div1M2 } from "./manzanasCluster2/Manzana6Div1M2";
import { Manzana7Div1M2 } from "./manzanasCluster2/Manzana7Div1M2";
import { Manzana8Div1M2 } from "./manzanasCluster2/Manzana8Div1M2";
import { Manzana9Div1M2 } from "./manzanasCluster2/Manzana9Div1M2";

import { Manzana10Div1M2 } from "./manzanasCluster2/Manzana10Div1M2";
import { Manzana11Div1M2 } from "./manzanasCluster2/Manzana11Div1M2";
import { Manzana12Div1M2 } from "./manzanasCluster2/Manzana12Div1M2";
import { Manzana13Div1M2 } from "./manzanasCluster2/Manzana13Div1M2";
import { Manzana14Div1M2 } from "./manzanasCluster2/Manzana14Div1M2";
import { Manzana15Div1M2 } from "./manzanasCluster2/Manzana15Div1M2";
import { Manzana16Div1M2 } from "./manzanasCluster2/Manzana16Div1M2";
import { Manzana17Div1M2 } from "./manzanasCluster2/Manzana17Div1M2";
import { Manzana18Div1M2 } from "./manzanasCluster2/Manzana18Div1M2";
import { Manzana19Div1M2 } from "./manzanasCluster2/Manzana19Div1M2";
import { Manzana19Div2M2 } from "./manzanasCluster2/Manzana19Div2M2";

import { Manzana20Div1M2 } from "./manzanasCluster2/Manzana20Div1M2";
import { Manzana21Div1M2 } from "./manzanasCluster2/Manzana21Div1M2";
import { Manzana22Div1M2 } from "./manzanasCluster2/Manzana22Div1M2";
import { Manzana23Div1M2 } from "./manzanasCluster2/Manzana23Div1M2";
import { Manzana24Div1M2 } from "./manzanasCluster2/Manzana24Div1M2";
import { Manzana25Div1M2 } from "./manzanasCluster2/Manzana25Div1M2";
import { Manzana26Div1M2 } from "./manzanasCluster2/Manzana26Div1M2";
import { Manzana27Div1M2 } from "./manzanasCluster2/Manzana27Div1M2";
import { Manzana28Div1M2 } from "./manzanasCluster2/Manzana28Div1M2";
import { Manzana29Div1M2 } from "./manzanasCluster2/Manzana29Div1M2";

import { Manzana30Div1M2 } from "./manzanasCluster2/Manzana30Div1M2";
import { Manzana31Div1M2 } from "./manzanasCluster2/Manzana31Div1M2";
import { Manzana32Div1M2 } from "./manzanasCluster2/Manzana32Div1M2";
import { Manzana33Div1M2 } from "./manzanasCluster2/Manzana33Div1M2";
import { Manzana34Div1M2 } from "./manzanasCluster2/Manzana34Div1M2";
import { Manzana35Div1M2 } from "./manzanasCluster2/Manzana35Div1M2";
import { Manzana35Div2M2 } from "./manzanasCluster2/Manzana35Div2M2";
import { Manzana35Div3M2 } from "./manzanasCluster2/Manzana35Div3M2";
import { Manzana36Div1M2 } from "./manzanasCluster2/Manzana36Div1M2";
import { Manzana37Div1M2 } from "./manzanasCluster2/Manzana37Div1M2";
import { Manzana38Div1M2 } from "./manzanasCluster2/Manzana38Div1M2";
import { Manzana39Div1M2 } from "./manzanasCluster2/Manzana39Div1M2";

import { Manzana40Div1M2 } from "./manzanasCluster2/Manzana40Div1M2";
import { Manzana41Div1M2 } from "./manzanasCluster2/Manzana41Div1M2";
import { Manzana42Div1M2 } from "./manzanasCluster2/Manzana42Div1M2";
import { Manzana43Div1M2 } from "./manzanasCluster2/Manzana43Div1M2";
import { Manzana44Div1M2 } from "./manzanasCluster2/Manzana44Div1M2";
import { Manzana45Div1M2 } from "./manzanasCluster2/Manzana45Div1M2";
import { Manzana46Div1M2 } from "./manzanasCluster2/Manzana46Div1M2";
import { Manzana46Div2M2 } from "./manzanasCluster2/Manzana46Div2M2";
import { Manzana46Div3M2 } from "./manzanasCluster2/Manzana46Div3M2";
import { Manzana46Div4M2 } from "./manzanasCluster2/Manzana46Div4M2";
import { Manzana46Div5M2 } from "./manzanasCluster2/Manzana46Div5M2";
import { Manzana46Div6M2 } from "./manzanasCluster2/Manzana46Div6M2";
import { Manzana46Div7M2 } from "./manzanasCluster2/Manzana46Div7M2";
import { Manzana46Div8M2 } from "./manzanasCluster2/Manzana46Div8M2";
import { Manzana46Div9M2 } from "./manzanasCluster2/Manzana46Div9M2";
import { Manzana46Div10M2 } from "./manzanasCluster2/Manzana46Div10M2";

import { Manzana47Div1M2 } from "./manzanasCluster2/Manzana47Div1M2";
import { Manzana48Div1M2 } from "./manzanasCluster2/Manzana48Div1M2";
import { Manzana49Div1M2 } from "./manzanasCluster2/Manzana49Div1M2";

import { Manzana50Div1M2 } from "./manzanasCluster2/Manzana50Div1M2";
import { Manzana51Div1M2 } from "./manzanasCluster2/Manzana51Div1M2";
import { Manzana52Div1M2 } from "./manzanasCluster2/Manzana52Div1M2";
import { Manzana53Div1M2 } from "./manzanasCluster2/Manzana53Div1M2";
import { Manzana54Div1M2 } from "./manzanasCluster2/Manzana54Div1M2";
import { Manzana55Div1M2 } from "./manzanasCluster2/Manzana55Div1M2";
import { Manzana56Div1M2 } from "./manzanasCluster2/Manzana56Div1M2";
import { Manzana57Div1M2 } from "./manzanasCluster2/Manzana57Div1M2";
import { Manzana58Div1M2 } from "./manzanasCluster2/Manzana58Div1M2";
import { Manzana59Div1M2 } from "./manzanasCluster2/Manzana59Div1M2";
import { Manzana59Div2M2 } from "./manzanasCluster2/Manzana59Div2M2";

import { Manzana60Div1M2 } from "./manzanasCluster2/Manzana60Div1M2";
import { Manzana61Div1M2 } from "./manzanasCluster2/Manzana61Div1M2";
import { Manzana62Div1M2 } from "./manzanasCluster2/Manzana62Div1M2";
import { Manzana63Div1M2 } from "./manzanasCluster2/Manzana63Div1M2";
import { Manzana64Div1M2 } from "./manzanasCluster2/Manzana64Div1M2";
import { Manzana65Div1M2 } from "./manzanasCluster2/Manzana65Div1M2";
import { roles } from "../../../../constants/roles";
import { Manzana66Div1M2 } from "./manzanasCluster2/Manzana66Div1M2";
import { Manzana67Div1M2 } from "./manzanasCluster2/Manzana67Div1M2";
import { Manzana68Div1M2 } from "./manzanasCluster2/Manzana68Div1M2";
import { Manzana69Div1M2 } from "./manzanasCluster2/Manzana69Div1M2";

import { Manzana70Div1M2 } from "./manzanasCluster2/Manzana70Div1M2";
import { Manzana71Div1M2 } from "./manzanasCluster2/Manzana71Div1M2";
import { Manzana72Div1M2 } from "./manzanasCluster2/Manzana72Div1M2";
import { Manzana73Div1M2 } from "./manzanasCluster2/Manzana73Div1M2";
import { Manzana74Div1M2 } from "./manzanasCluster2/Manzana74Div1M2";
import { Manzana75Div1M2 } from "./manzanasCluster2/Manzana75Div1M2";
import { Manzana76Div1M2 } from "./manzanasCluster2/Manzana76Div1M2";
import { Manzana77Div1M2 } from "./manzanasCluster2/Manzana77Div1M2";
import { Manzana78Div1M2 } from "./manzanasCluster2/Manzana78Div1M2";
import { Manzana79Div1M2 } from "./manzanasCluster2/Manzana79Div1M2";
import { Manzana79Div2M2 } from "./manzanasCluster2/Manzana79Div2M2";

import { Manzana80Div1M2 } from "./manzanasCluster2/Manzana80Div1M2";
import { Manzana81Div1M2 } from "./manzanasCluster2/Manzana81Div1M2";
import { Manzana81Div2M2 } from "./manzanasCluster2/Manzana81Div2M2";
import { Manzana81Div3M2 } from "./manzanasCluster2/Manzana81Div3M2";
import { Manzana81Div4M2 } from "./manzanasCluster2/Manzana81Div4M2";
import { Manzana81Div5M2 } from "./manzanasCluster2/Manzana81Div5M2";
import { Manzana81Div6M2 } from "./manzanasCluster2/Manzana81Div6M2";
import { Manzana82Div1M2 } from "./manzanasCluster2/Manzana82Div1M2";
import { Manzana83Div1M2 } from "./manzanasCluster2/Manzana83Div1M2";
import { Manzana84Div1M2 } from "./manzanasCluster2/Manzana84Div1M2";
import { Manzana85Div1M2 } from "./manzanasCluster2/Manzana85Div1M2";
import { Manzana86Div1M2 } from "./manzanasCluster2/Manzana86Div1M2";
import { Manzana87Div1M2 } from "./manzanasCluster2/Manzana87Div1M2";
import { Manzana87Div2M2 } from "./manzanasCluster2/Manzana87Div2M2";
import { Manzana88Div1M2 } from "./manzanasCluster2/Manzana88Div1M2";
import { Manzana89Div1M2 } from "./manzanasCluster2/Manzana89Div1M2";
import { Manzana89Div2M2 } from "./manzanasCluster2/Manzana89Div2M2";

import { Manzana90Div1M2 } from "./manzanasCluster2/Manzana90Div1M2";
import { Manzana91Div1M2 } from "./manzanasCluster2/Manzana91Div1M2";
import { Manzana92Div1M2 } from "./manzanasCluster2/Manzana92Div1M2";
import { Manzana93Div1M2 } from "./manzanasCluster2/Manzana93Div1M2";
import { Manzana94Div1M2 } from "./manzanasCluster2/Manzana94Div1M2";
import { Manzana95Div1M2 } from "./manzanasCluster2/Manzana95Div1M2";
import { Manzana96Div1M2 } from "./manzanasCluster2/Manzana96Div1M2";
import { Manzana97Div1M2 } from "./manzanasCluster2/Manzana97Div1M2";
import { Manzana98Div1M2 } from "./manzanasCluster2/Manzana98Div1M2";
import { Manzana99Div1M2 } from "./manzanasCluster2/Manzana99Div1M2";

import { Manzana100Div1M2 } from "./manzanasCluster2/Manzana100Div1M2";
import { Manzana101Div1M2 } from "./manzanasCluster2/Manzana101Div1M2";
import { Manzana102Div1M2 } from "./manzanasCluster2/Manzana102Div1M2";
import { Manzana103Div1M2 } from "./manzanasCluster2/Manzana103Div1M2";
import { Manzana104Div1M2 } from "./manzanasCluster2/Manzana104Div1M2";
import { Manzana105Div1M2 } from "./manzanasCluster2/Manzana105Div1M2";
import { Manzana106Div1M2 } from "./manzanasCluster2/Manzana106Div1M2";
import { Manzana107Div1M2 } from "./manzanasCluster2/Manzana107Div1M2";
import { Manzana108Div1M2 } from "./manzanasCluster2/Manzana108Div1M2";
import { Manzana109Div1M2 } from "./manzanasCluster2/Manzana109Div1M2";
import { Manzana110Div1M2 } from "./manzanasCluster2/Manzana110Div1M2";
import { Manzana111Div1M2 } from "./manzanasCluster2/Manzana111Div1M2";
import { Manzana112Div1M2 } from "./manzanasCluster2/Manzana112Div1M2";
import { Manzana113Div1M2 } from "./manzanasCluster2/Manzana113Div1M2";
import { Manzana114Div1M2 } from "./manzanasCluster2/Manzana114Div1M2";
import { Manzana115Div1M2 } from "./manzanasCluster2/Manzana115Div1M2";


import zihuaLogo from "../../../../assets/home/images/logo-fuerza-migrante.png";
import { FaArrowLeft } from "react-icons/fa6";
import ClusterText from "./component/ClusterText";



export const GeneralMap = ({ isPublic = false, onClusterSelected }) => {
  const [mapSelected, setMapSelected] = useState({
    section: null,
    group: null,
    land: null,
    manzana: null,
  });
  const [loading, setLoading] = useState(false);
  // lands catalog
  const [lands, setLands] = useState([]);
  const [landSelected, setLandSelected] = useState(null);
  const [first, setFirst] = useState(true);

  const { user: authUser } = useAuth();
  const { client: user } = useSelector((state) => state.user); // user selected
  const [isVisible, setIsVisible] = useState(false);
  const [position, setPosition] = useState({ top: 100, left: 150 });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userId } = useParams();
  const role = authUser?.user?.roles?.[0]?.name?.toLowerCase?.();

  const { handleSubmit, watch, setValue } = useForm({
    mode: "onSubmit",
    defaultValues: {
      periods: 120,
    },
  });

  const landWatcher = watch("land");

  const fetchLands = useCallback(async () => {
    try {
      const group = mapSelected.group;
      const manzana = mapSelected.manzana;
      const section = mapSelected.section;
      const response = await getLotLands({
        pagination: false,
        section,
        manzana,
      });
      setLands(response.data.data);
      setLoading(false);
    } catch (error) {
      toast.error(error.message);
    }
  }, [mapSelected.group, mapSelected.section]);

  useEffect(() => {
    if (window.innerWidth < 1000) {
      if (window.innerWidth < 700) {
        setPosition({
          top: 100,
          left: 480,
        });
      } else {
        setPosition({
          top: 100,
          left: 450,
        });
      }
    }
    if (mapSelected.group && mapSelected.section) {
      fetchLands();
    }
  }, [fetchLands, first, mapSelected]);

  const sectionHandler = (sectionId) => {
    // onClusterSelected(true);
    if (sectionId === 2) {
      setMapSelected({ section: sectionId, group: null, land: null });
      return;
    }
    return setMapSelected({ section: sectionId, group: null, land: null });
  };

  const groupHandler = (sectionId, manzanaId, groupId) => {
    setLoading(true);
    setMapSelected({
      ...mapSelected,
      section: sectionId,
      group: groupId,
      manzana: manzanaId,
    });
  };

  const handleBackManzana = useCallback((sectionId = 1) => {
    setLoading(true);
    setMapSelected({ section: sectionId, group: null, manzana: null });
    setLoading(false);
  },[]);

  const handleBackSection = useCallback(() => {
    setLoading(true);
    setMapSelected({ section: null, group: null, manzana: null });
    setLoading(false);
  }, []);

  const landHandler = (e, land) => {
    e.preventDefault();
    // const rect = e.target.getBoundingClientRect();
    // setPosition({
    //           top: rect.top + window.scrollY,
    //           left: rect.left + window.scrollX + rect.width / 2,
    //         });
    setValue('land', land);
    setIsVisible(true);
    setLandSelected(land);
  };

  // submit
  const submit = (data) => {
    if (isPublic) {
      window.location.href = "#contacto";
      return null;
    }

    // convert years to months
    const monthsPeriod = data.periods;
    let client = null;
    let userPayload = null;

    client = user.client.id;
    userPayload = user.id;

    const payload = {
      client_id: client,
      land_id: data.land.id,
      periods: monthsPeriod,
      interest: 0,
    };

    dispatch(assignLand({ land: payload.land_id, params: payload }));
    dispatch(selectClient(user));

    dispatch(
      saveProgress({
        user: userPayload,
        payload: {
          data: payload,
          step: 3,
          name: "sales",
          land: payload.land_id,
        },
      })
    ).then((response) => {
      const isClient = role.toLowerCase() === roles.CLIENT;
      // set user selected
      if (userId) {
        isClient ? navigate(`/admin/home`) : navigate(`/admin/details/${user?.id}/${userId}`);
      } else {
        isClient ? navigate(`/admin/home`) : navigate(`/admin/details/${user?.id}`);
      }
    });
  };

  if (loading) {
    return <Loading />;
  }

  if (!mapSelected.section) {
    //TODO: General Map component Cluster 1 and 2
    return <C1AndC2Map onClickHandler={sectionHandler} />;
  }

  /*if (!mapSelected.section) {
  //TODO: General Map component Cluster 1
        return <General onClickHandler={sectionHandler}/>
    }*/

  if (mapSelected.section === 2 && !mapSelected.group) {
    //TODO: change to cluster 2
    return (
      <Cluster2
      onClickHandler={groupHandler}
      onBack={handleBackSection}
      />
    );
  }

  if (mapSelected.section === 1 && !mapSelected.group) {
    return (
        <SectionMap onClickHandler={groupHandler} onBack={handleBackSection} />
    );
  }
/***Sección 2 */
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 1) {
    return (
      <>
        <div className="relative max-md:overflow-x-auto max-md:scrollbar-hide">
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana1Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </div>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 2) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana2Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 2 && mapSelected.manzana === 2) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana2Div2M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 3 && mapSelected.manzana === 2) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana2Div3M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 3) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana3Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 2 && mapSelected.manzana === 3) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana3Div2M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 4) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana4Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 5) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana5Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 6) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana6Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 7) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana7Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 8) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana8Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 9) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana9Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 10) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana10Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 11) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana11Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 12) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana12Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 13) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana13Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 14) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana14Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 15) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana15Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 16) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana16Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 17) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana17Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 18) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana18Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 19) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana19Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 2 && mapSelected.manzana === 19) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana19Div2M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 20) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana20Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 21) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana21Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }  
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 22) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana22Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }  
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 23) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana23Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }  
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 24) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana24Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 25) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana25Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 26) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana26Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 27) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana27Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 28) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana28Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 29) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana29Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 30) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana30Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 31) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana31Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 32) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana32Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 33) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana33Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 34) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana34Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 35) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana35Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 2 && mapSelected.manzana === 35) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana35Div2M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 3 && mapSelected.manzana === 35) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana35Div3M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 36) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana36Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 37) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana37Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 38) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana38Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 39) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana39Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 40) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana40Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 41) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana41Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 42) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana42Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 43) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana43Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 44) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana44Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 45) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana45Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 46) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana46Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 2 && mapSelected.manzana === 46) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana46Div2M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 3 && mapSelected.manzana === 46) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana46Div3M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 4 && mapSelected.manzana === 46) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana46Div4M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 5 && mapSelected.manzana === 46) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana46Div5M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 6 && mapSelected.manzana === 46) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana46Div6M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 7 && mapSelected.manzana === 46) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana46Div7M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 8 && mapSelected.manzana === 46) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana46Div8M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 9 && mapSelected.manzana === 46) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana46Div9M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 10 && mapSelected.manzana === 46) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana46Div10M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 47) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana47Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 48) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana48Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 49) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana49Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 50) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana50Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 51) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana51Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 52) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana52Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 53) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana53Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 54) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana54Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 55) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana55Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 56) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana56Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 57) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana57Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 58) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana58Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 59) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana59Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 2 && mapSelected.manzana === 59) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana59Div2M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 60) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana60Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 61) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana61Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 62) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana62Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 63) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana63Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 64) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana64Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 65) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana65Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 66) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana66Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 67) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana67Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 68) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana68Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 69) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana69Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 70) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana70Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 71) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana71Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 72) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana72Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 73) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana73Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 74) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana74Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 75) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana75Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 76) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana76Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 77) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana77Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 78) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana78Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 79) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana79Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 2 && mapSelected.manzana === 79) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana79Div2M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 80) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana80Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 81) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana81Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 2 && mapSelected.manzana === 81) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana81Div2M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 3 && mapSelected.manzana === 81) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana81Div3M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 4 && mapSelected.manzana === 81) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana81Div4M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 5 && mapSelected.manzana === 81) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana81Div5M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 6 && mapSelected.manzana === 81) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana81Div6M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 82) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana82Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 83) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana83Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 84) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana84Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 85) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana85Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 86) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana86Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 87) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana87Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 2 && mapSelected.manzana === 87) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana87Div2M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 88) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana88Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 89) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana89Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 2 && mapSelected.manzana === 89) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana89Div2M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 90) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana90Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 91) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana91Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 92) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana92Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 93) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana93Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 94) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana94Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 95) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana95Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 96) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana96Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 97) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana97Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 98) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana98Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 99) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana99Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 100) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana100Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 101) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana101Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 102) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana102Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 103) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana103Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 104) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana104Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 105) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana105Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 106) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana106Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 107) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana107Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 108) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana108Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 109) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana109Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 110) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana110Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 111) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana111Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 112) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana112Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 113) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana113Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 114) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana114Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
  if (mapSelected.section === 2 && mapSelected.group === 1 && mapSelected.manzana === 115) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"02"} onGoBack={() => handleBackManzana(2)}/>
          <Manzana115Div1M2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(2)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
/***Sección 1 */
  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 1) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
        <Manzana1Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 2 && mapSelected.manzana === 1) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana1Div2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 2) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana2Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 3) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana3Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 4) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana4Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 5) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana5Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 6) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana6Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 7) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana7Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 8) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana8Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 9) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana9Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 10) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana10Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 11) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana11Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 12) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana12Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 13) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana13Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 14) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana14Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 15) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana15Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 2 && mapSelected.manzana === 15) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana15Div2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 3 && mapSelected.manzana === 15) {
    return (
      <>
      <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana15Div3
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 16) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana16Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 17) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana17Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 18) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana18Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 19) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana19Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 20) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana20Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 21) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana21Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 22) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana22Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 23) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana23Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 24) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana24Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 25) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana25Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 26) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana26Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 27) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana27Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 28) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana28Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 29) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana29Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 30) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana30Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 31) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana31Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 32) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana32Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 33) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana33Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 34) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana34Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 35) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana35Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 2 && mapSelected.manzana === 35) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana35Div2
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 3 && mapSelected.manzana === 35) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana35Div3
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 36) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana36Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 37) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana37Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }

  if (mapSelected.section === 1 && mapSelected.group === 1 && mapSelected.manzana === 38) {
    return (
      <>
        <section className="relative max-md:overflow-x-auto max-md:scrollbar-hide">  
        <ClusterText cluster={"01"} onGoBack={() => handleBackManzana(1)}/>
          <Manzana38Div1
            landSelector={landHandler}
            lands={lands}
            selected={landSelected}
          />
          <div>
            {isVisible && (
              <DetailsCard
                clusterId={mapSelected?.section}
                position={position}
                land={landWatcher}
                submit={handleSubmit(submit)}
                onGoBack={() => handleBackManzana(1)}
                onClose={() => setIsVisible(false)}
              >
                <LandDetails land={landWatcher} />
              </DetailsCard>
            )}
          </div>
        </section>
      </>
    );
  }
};
